import { render } from "./Login-Page.vue?vue&type=template&id=9c00960c&scoped=true"
import script from "./Login-Page.vue?vue&type=script&lang=js"
export * from "./Login-Page.vue?vue&type=script&lang=js"

import "./Login-Page.vue?vue&type=style&index=0&id=9c00960c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c00960c"]])

export default __exports__